import React, { useEffect, useState } from "react";
import "./ListCategory.css";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function StallCategories() {
  const location = useLocation();
  const navigate = useNavigate();

  // ⬇️ Receiving values from previous screen
  const stall_id = location.state?.stall_id;
  const stall = location.state?.stall;
  const owner = location.state?.owner;
  const owner_id = location.state?.owner_id; // 🔥 Correct owner_id from previous navigation

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = "https://fliplyn-b-c.fly.dev";

  // 🔥 Debug Logs
  console.log("======== LIST CATEGORY SCREEN LOADED ========");
  console.log("stall_id =>", stall_id);
  console.log("owner_id =>", owner_id);
  console.log("stall =>", stall);
  console.log("owner =>", owner);
  console.log("============================================");

  useEffect(() => {
    if (!stall_id) return;

    const getCategories = async () => {
      try {
        const res = await axios.get(`${API}/categories/stall/${stall_id}`);
        setCategories(res.data);
        console.log("🟢 CATEGORIES LOADED =>", res.data);
      } catch (err) {
        console.error("❌ Error fetching categories:", err);
      } finally {
        setLoading(false);
      }
    };

    getCategories();
  }, [stall_id]);

  if (!stall_id) {
    return (
      <h1 style={{ textAlign: "center", marginTop: 50 }}>
        Stall ID Not Found
      </h1>
    );
  }

  return (
    <div className="stall-category-container">
      <AdminHeader />

      {/* Stall Header Card */}
      <div className="stall-header-card">
        <div>
          <h1 className="stall-title">{stall?.name || "Unnamed Stall"}</h1>
          <p className="stall-subtitle">{stall?.cuisine || "Cuisine Type"}</p>

          <div className="stall-owner-label">OWNER</div>
          <div className="stall-header-row">
            <span className="stall-owner-name">
              {owner?.owner_name || "Unknown"}
            </span>

            <div className="stall-timing-row">
              <span className="stall-badge open">
                ⏱ Opens at {stall?.opening_time || "--"}
              </span>
              <span className="stall-badge close">
                ⏱ Closes at {stall?.closing_time || "--"}
              </span>
            </div>
          </div>
        </div>

        <button
          className="stall-view-btn"
          onClick={() =>
            navigate("/list-items", {
              state: { stall_id, stall, owner, owner_id },
            })
          }
        >
          View all Items in this stall       

        </button>
          <button
          className="add-vendor"
          onClick={() =>
            navigate("/add-vendor", {
              state: { stall_id, stall, owner, owner_id },
            })
          }
        >
          Add Vendor
        </button>
      </div>

      <div className="padding-for-category">
        {/* Section Title */}
        <div className="stall-category-header-row">
          <h2>Outlet Categories</h2>
          <button
            className="stall-add-btn"
            onClick={() =>
              navigate("/add-category", {
                state: { stall_id, stall, owner, owner_id },
              })
            }
          >
            + Add Category
          </button>
        </div>

        {/* Category Grid */}
        {loading ? (
          <h3 style={{ textAlign: "center", marginTop: 50 }}>
            Loading categories...
          </h3>
        ) : categories.length === 0 ? (
          <h3 style={{ textAlign: "center", marginTop: 40 }}>
            No categories found
          </h3>
        ) : (
          <div className="stall-category-grid">
            {categories.map((cat) => (
              <div
                key={cat.id}
                className="stall-category-card"
                onClick={() =>
                  navigate("/list-items", {
                    state: { stall_id, stall, owner, owner_id, category: cat },
                  })
                }
              >
                <div className="stall-cat-left">
                  <img
                    src={cat.image_url}
                    alt=""
                    className="stall-cat-icon"
                  />
                  <div>
                    <h3 className="stall-cat-title">{cat.name}</h3>
                    <p className="stall-cat-items">Click to view items</p>
                  </div>
                </div>

                <div className="stall-cat-menu">⋮</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
